import { Component, Input } from '@angular/core';

@Component({
  selector: 'tree-node-expander',
  template: `
    <span
      class="ecpl-node-expander"
      (click)="toggle($event)"
      [style.cursor]="'pointer'"
    >
      <i
        [class]="node.isExpanded ? 'fas fa-caret-down' : 'fas fa-caret-right'"
      ></i>
    </span>
  `,
  standalone: false
})
export class TreeNodeExpanderComponent {
  @Input() node: any;

  toggle(ev?: Event) {
    ev && ev.stopPropagation();
    if (this.node && typeof this.node.toggleExpand === 'function') {
      this.node.toggleExpand();
    } else if (this.node) {
      this.node.isExpanded = !this.node.isExpanded;
    }
  }
}
